import { render, staticRenderFns } from "./byCustomers.vue?vue&type=template&id=707df162&scoped=true&"
import script from "./byCustomers.vue?vue&type=script&lang=js&"
export * from "./byCustomers.vue?vue&type=script&lang=js&"
import style0 from "./byCustomers.vue?vue&type=style&index=0&id=707df162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707df162",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
